import { logWithOffset } from "./logWithOffset";
import { setupValidation } from './checkout_form';
/*

  Any functon that gets exposed needs to be sure it doesn't cause a loop
  with respect to onCartUpdate callbacks.

  - applyCoupon needs to check the same coupon isn't already in the cart

  - setVariantQuantities needs to be sure that the cart isn't already in that state.

*/


export class RTC {
  constructor(checkout) {
    logWithOffset(`Exposing methods on RTC Global`);


    const exposedMethods = [
      "setVariantQuantities",
      "getVariantQuantities",
      "currentShippingZone",
      "setNextUrlFn",
      "removeCoupon",
      "applyCoupon",
      "currentCouponCode",
      "getVariantData",
      "setLineItemHtmlFn",
      "fillAddresses",
      "setCurrencyFormatterCallback",
      "resetSession"
    ];

    this.log = logWithOffset;

    // We re-name this in its exposed version.
    this.acceptUpsellVariants = checkout.acceptUpsellGridData.bind(checkout);
    this.setCurrentVariant    = checkout.setCurrentVariantManual.bind(checkout);
    this.formatCurrency       = checkout.currencyFormatter.bind(checkout);
    this.jQuery               = checkout.jQuery;
    this.setupValidation      = setupValidation;

    exposedMethods.forEach(method => {
      if (!checkout[method]) {
        logWithOffset(`WARNING: '${method}' is missing from internal object, cannot expose`);
      } else {
        this[method] = typeof(checkout[method]) === 'function' ? checkout[method].bind(checkout) : checkout[method];
      }
    });
  }
}
